import React from 'react';

interface HeroNavigationProps {
  totalSlides: number;
  currentSlide: number;
  onSlideChange: (index: number) => void;
  variant?: 'mobile' | 'desktop';
}

export const HeroNavigation: React.FC<HeroNavigationProps> = ({
  totalSlides,
  currentSlide,
  onSlideChange,
  variant = 'mobile',
}) => {
  if (variant === 'mobile') {
    return (
      <div className="flex lg:hidden justify-center gap-2 mt-12 relative z-50 pointer-events-auto">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={`mobile-dot-${index}`}
            onClick={() => onSlideChange(index)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer touch-manipulation ${index === currentSlide
                ? 'w-12 h-3 bg-[#377396]'
                : 'w-4 h-3 bg-gray-300 hover:bg-gray-400'
              }`}
            aria-label={`Ir para slide ${index + 1}`}
            type="button"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="container p-4 sm:p-6 lg:p-8 relative h-full w-full mx-auto">
      {/* Posicionamento responsivo com clamp para evitar sobreposição com métricas */}
      <div
        className="absolute left-6 z-40 hidden lg:flex gap-3"
        style={{
          bottom: 'clamp(160px, 20vh, 240px)'
        }}
      >
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={`desktop-dot-${index}`}
            onClick={() => onSlideChange(index)}
            className={`h-3 rounded-full transition-all duration-300 cursor-pointer ${index === currentSlide
                ? 'w-12 h-3 bg-[#377396]'
                : 'w-4 h-3 bg-gray-300 hover:bg-gray-400'
              }`}
            aria-label={`Ir para slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
